package com.gsb.vyapar.bhagya.presentation.navigation.view

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.domain.getWebsite
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButtonSmall
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImage
import com.gsb.vyapar.bhagya.presentation.common.image.SmoothImage
import com.gsb.vyapar.bhagya.presentation.common.image.SocialPlaceHolder
import com.gsb.vyapar.bhagya.presentation.common.image.StorePlaceHolder
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularB
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularBB
import com.gsb.vyapar.bhagya.presentation.common.toolbar.Toolbar
import com.gsb.vyapar.bhagya.presentation.navigation.util.showClearData
import com.gsb.vyapar.bhagya.share
import com.gsb.vyapar.bhagya.theme.*
import com.gsb.vyapar.bhagya.util.*
import org.jetbrains.compose.resources.painterResource
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@OptIn(ExperimentalTime::class)
@Composable
fun AboutView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    val uriHandler = LocalUriHandler.current
    var tapCount by remember { mutableStateOf(0) }
    var lastTapTime by remember { mutableStateOf(0L) }
    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
        ) {
            Toolbar("About GSB-VyaparBhagya")
            Column(
                modifier = Modifier.verticalScroll(rememberScrollState()).fillMaxWidth()
                    .padding(16.dp),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Spacer(Modifier.height(15.dp))
                CommonImage(painterResource(splash), Modifier.width(200.dp).height(200.dp).clickable {
                    val currentTime = Clock.System.now().toEpochMilliseconds()
                    if (currentTime - lastTapTime > 1000) {
                        tapCount = 0
                    }
                    lastTapTime = currentTime
                    tapCount++
                    if (tapCount == 5) {
                        showClearData()
                        tapCount = 0
                    }
                })
                Spacer(Modifier.height(15.dp))
                Text14RegularB(getAbout(), black)
                Spacer(Modifier.height(15.dp))
                Text14RegularBB(getEmail(), Color.Blue, Modifier.clickable { uriHandler.openUri("mailto:${getEmail()}") })
                Spacer(Modifier.height(15.dp))
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.Start) {
                    Text14RegularB("Contact Us:", black)
                }
                Spacer(Modifier.height(8.dp))
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceEvenly) {
                    SocialPlaceHolder(facebook, modifier = Modifier.clickable { uriHandler.openUri(getFb()) })
                    SocialPlaceHolder(twitter, modifier = Modifier.clickable { uriHandler.openUri(getX()) })
                    SocialPlaceHolder(instagram, modifier = Modifier.clickable { uriHandler.openUri(getInst()) })
                    SocialPlaceHolder(mail, modifier = Modifier.clickable { uriHandler.openUri("mailto:${getEmail()}") })
                    SocialPlaceHolder(whatsapp, modifier = Modifier.clickable { uriHandler.openUri("https://wa.me/+91${getMobile()}") })
                    SocialPlaceHolder(web, modifier = Modifier.clickable { uriHandler.openUri(getWebsite()) })
                }
                if (BuildConfig.platform() != PlatformType.IOS) {
                    Spacer(Modifier.height(8.dp))
                    Text14RegularB("App is available in PlayStore, AppStore & Web:", black)
                    Spacer(Modifier.height(8.dp))
                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.Center) {
                        StorePlaceHolder(googlestore, modifier = Modifier.clickable { uriHandler.openUri(getAndroid()) })
                        Spacer(Modifier.width(10.dp))
                        StorePlaceHolder(applestore, modifier = Modifier.clickable { uriHandler.openUri(getIos()) })
                        Spacer(Modifier.width(10.dp))
                        StorePlaceHolder(webstore, modifier = Modifier.clickable { uriHandler.openUri(getWebApp()) })
                    }
                }
                Spacer(Modifier.height(8.dp))
                Text14RegularB(getSupport(), black)
                Spacer(Modifier.height(16.dp))
                SmoothImage(
                    uiState.getImage(getUpi()),
                    width = 150.dp,
                    height = 150.dp
                )
                Spacer(Modifier.height(16.dp))
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.Center) {
                    GVBButtonSmall(text = "Support Us") { uriHandler.openUri(uiState.getInfo().getWebsite()) }
                    Spacer(Modifier.width(40.dp))
                    GVBButtonSmall(text = "Share") { share(getShare()) }
                }
                Spacer(Modifier.weight(1f))
                Row(modifier = Modifier.fillMaxWidth().padding(top = 16.dp), horizontalArrangement = Arrangement.SpaceBetween) {
                    Text14RegularB("Privacy Policy", primary, Modifier.clickable { uriHandler.openUri(getPrivacyUrl()) })
                    Text14RegularB("Terms & Conditions", primary, Modifier.clickable { uriHandler.openUri(getTermsUrl()) })
                }
            }
        }
    }
}